/**
 * admin/src/App.js
 * Root router for the Platform Admin standalone app.
 * Two routes only: /login and / (the panel itself, protected).
 */
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import theme from "@urbamart/shared/theme";
import ProtectedPlatformAdminRoute from "./routes/ProtectedPlatformAdminRoute";

const Login         = lazy(() => import("./pages/Login"));
const PlatformAdmin = lazy(() => import("./pages/PlatformAdmin"));

function PageLoader() {
  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      height: "100dvh", background: theme.colors.bg,
    }}>
      <div className="skeleton" style={{ width: 48, height: 48, borderRadius: "50%" }} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Protected — platform_admin only */}
          <Route
            path="/"
            element={
              <ProtectedPlatformAdminRoute>
                <PlatformAdmin />
              </ProtectedPlatformAdminRoute>
            }
          />

          {/* Fallback — redirect everything else to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
